import { render, staticRenderFns } from "./ContentBlockBase.vue?vue&type=template&id=eaf23f0a&scoped=true&functional=true&"
var script = {}
import style0 from "./ContentBlockBase.vue?vue&type=style&index=0&id=eaf23f0a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "eaf23f0a",
  null
  
)

export default component.exports